var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vc-calendar',{staticClass:"mobile-calendar",attrs:{"mode":"range","is-expanded":"","attributes":_vm.calendarShifts,"from-page":_vm.firstShiftDate,"locale":{ firstDayOfWeek: 2, masks: { weekdays: 'WW' } }}})
}
var staticRenderFns = []

export { render, staticRenderFns }